import React, { useEffect, useMemo, useRef, useState } from "react";
import "./componentStyle.css";
import "reactjs-popup/dist/index.css";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/system";
import { Icon } from "@iconify/react";
import {
  Button,
  Fade,
  FormControl,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import axios from "axios";
import Popup from "./Popup";
import { set } from "date-fns";
import { useNavigate, useParams } from "react-router-dom";

const TicketsDetailsPopUp = ({ flag, handleClose, id, setLoder, Loder }) => {
  const { ticketId } = useParams();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [allData, setAllData] = useState("");
  const [commetData, setCommetData] = useState("");
  const [ClientComments, setClientComments] = useState("");
  const [uploadFile, setUploadFile] = useState(null);
  const [responseMsg, setresponseMsg] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [imageURL, setImageURL] = useState(null);
  const [imageData, setImageData] = useState(null);
  const imageRef = useRef(null);
  const [uploadFiles, setUploadFiles] = useState([]);

  const [sessionResponse, setSessionResponse] = useState("");
  const [sessionFlag, setSessionFlag] = useState(false);

  const fileInputRef = useRef(null);

  const [fileNames, setFileNames] = useState([]);
  const navigate = useNavigate();
  const [timeoutFlag, setTimeoutFlag] = useState(false);

  useEffect(() => {
    const ticketIdToUse = id || ticketId;
    if (ticketIdToUse) {
      setLoder(true);
      axios.get(`/meonsupport/checkStatus/${ticketIdToUse}`, { timeout: 20000})
        .then((response) => {
          // console.log("response", response.data);
          if (response.data === "Logged out") {
            setSessionResponse("Session expired. Please login again.");
            setSessionFlag(true);
            sessionStorage.removeItem("token");
          } 
          else if (response.data?.data === "Issue does not exist or you do not have permission to see it.") {
            // console.log("this is unauth");
            handleClose();
          }
          else {
            const resData = response.data || {};
            const commentData = response.data?.comment || {};
            // const resData = {};
            // const commentData = {};

            setAllData(resData);
            // console.log("All data: ", response.data);
            setCommetData(commentData);
            setErrMsg("");
          }
        })
        .catch((error) => {
          // console.error("Error fetching ticket status:", error);
          if (error.code === "ECONNABORTED") {
            setTimeoutFlag(true);
          } else {
            setErrMsg("Failed to fetch ticket status.");
          }
        })
        .finally(() => {
          setLoder(false);
        });
  
      // fetchComments(ticketIdToUse);
    }
  }, [id, ticketId]);

  const handleTimeoutClose = () => {
    setTimeoutFlag(false);
    window.location.reload();
  };

  const inputRef = useRef(null);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    uploadFiles.forEach((file) => {
      formData.append("files[]", file);
    });
    formData.append("comments", inputRef.current.value);
  
    if (inputRef.current.value) {
      setLoder(true);
      axios.post(`/meonsupport/add_comments/${id || ticketId}`, formData)
        .then((response) => {
          if (response.data === "Logged out") {
            setSessionResponse("Session expired. Please login again.");
            setSessionFlag(true);
            sessionStorage.removeItem("token");
          } else {
            setresponseMsg("Your comment has been inserted successfully!");
            fetchComments(id || ticketId);
            // setIsOpen(true);
            setErrMsg("");
          }
        })
        .catch((error) => {
          console.error("Error adding comment:");
          setErrMsg("Failed to add comment.");
        })
        .finally(() => {
          setLoder(false);
        });
    } else {
      setErrMsg("Comments cannot be empty.");
    }
  };

  useEffect(() => {
    if (ClientComments) {
      setLoder(true);
      axios.post(`/meonsupport/add_comments/${id || ticketId}`, ClientComments).then((response) => {
        if (response.data === "Logged out") {
          setSessionResponse("Session expired. Please login again.");
          setSessionFlag(true);
          sessionStorage.removeItem("token");
          // navigate("/login");
        } else {
          setAllData(response.data);
          setLoder(false);
          setresponseMsg("Your comment has been inserted succsessfully!");
          setErrMsg("");
        }

        setImageURL(null);
        if (imageRef.current) {
          imageRef.current.value = null;
        }

        setLoder(true);
        axios.get(`/meonsupport/checkStatus/${id || ticketId}`).then((response) => {
          if (response.data === "Logged out") {
            setSessionResponse("Session expired. Please login again.");
            setSessionFlag(true);
            sessionStorage.removeItem("token");
            // navigate("/login");
          } else {
            setAllData(response.data);
            setLoder(false);
          }
        });
      });
    }
  }, [ClientComments]);

  const fetchComments = (ticketIdToUse) => {
    setLoder(true);
    axios.get(`/meonsupport/checkStatus/${ticketIdToUse}`)
      .then((res) => {
        if (res.data === "Logged out") {
          setSessionResponse("Session expired. Please login again.");
          setSessionFlag(true);
          sessionStorage.removeItem("token");
        } else {
          const commentData = res.data?.comment || {};
          setCommetData(commentData);
          setErrMsg("");
        }
      })
      .catch((error) => {
        console.error("Error fetching comments:", error);
        setErrMsg("Failed to fetch comments.");
      })
      .finally(() => {
        setLoder(false);
      });
  };

  // const fetchComments = (ticketIdToUse) => {
  //   setLoder(true);
  //   axios.get(`/meonsupport/get_comments/${ticketIdToUse}`)
  //     .then((res) => {
  //       if (res.data === "Logged out") {
  //         setSessionResponse("Session expired. Please login again.");
  //         setSessionFlag(true);
  //         sessionStorage.removeItem("token");
  //       } else {
  //         setCommetData(res.data);
  //         setErrMsg("");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching comments:", error);
  //       setErrMsg("Failed to fetch comments.");
  //     })
  //     .finally(() => {
  //       setLoder(false);
  //     });
  // };

  // const fetchAttachments = (ticketIdToUse) => {
  //   setLoder(true);
  //   axios.get(`/meonsupport/getFiles/${ticketIdToUse}`)
  //     .then(response => {
  //       setFileNames(response.data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching files", error);
  //     })
  //     .finally(() => {
  //       setLoder(false);
  //     });
  // };

  // useEffect(() => {
  //   setLoder(true);
  //   axios.get(`/meonsupport/getFiles/${id}`)
  //     .then(response => {
  //       setFileNames(response.data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching files", error);
  //     });
  //   }, [id]);

  const handleClosePopUp = () => {
    setIsOpen(false);
  };

  const handleSessionClose = () => {
    setSessionFlag(false);
    navigate("/login");
  }

  // const handleDownload = (fileName) => {
  //   axios({
  //     url: `/meonsupport/uploadFiles/${id || ticketId}/${fileName}`,
  //     method: "GET",
  //     responseType: "blob",
  //   })
  //     .then((response) => {
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", fileName);
  //       document.body.appendChild(link);
  //       link.click();
  //       link.parentNode.removeChild(link);
  //     })
  //     .catch((error) => {
  //       console.error("Error downloading file:", error);
  //       setErrMsg("Failed to download file.");
  //     });
  // };
  
  const downloadFile = async (base_url, url, fileName) => {
    try {
      // Create a new URL object
      const apiUrl = new URL(`${base_url}/crm/download`);

      // Use URLSearchParams to safely add query parameters
      const params = new URLSearchParams();
      params.append('url', url);
      apiUrl.search = params.toString();

      // console.log('API_URL', apiUrl.toString());

      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error('Network response was not ok.');

      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the URL object
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading the file:');
    }
  };

  const handleDownload = async (imgSrc) => {
    const base_url = "https://crm.meon.co.in"
    const url = String(imgSrc);
    // const fileName = url.split('/').pop().split('?')[0];
    const fileName = url.substring(url.lastIndexOf('/') + 1, url.indexOf('?'));
    await downloadFile(base_url, url, fileName);
  };

  // const handlePaste = (event) => {
  //   fileInputRef.current.value = null;
  //   const items = event.clipboardData.items;

  //   for (let i = 0; i < items.length; i++) {
  //     const item = items[i];
  //     if (item.type.indexOf("image") === 0) {
  //       const blob = item.getAsFile();
  //       setImageData(blob);
  //       const imageURL = URL.createObjectURL(blob);
  //       console.log("imageURL", imageURL);

  //       setImageURL(imageURL);
  //     }
  //   }
  // };

  const handlePaste = (event) => {
    fileInputRef.current.value = null;
    const items = event.clipboardData.items;
    const maxSize = 10 * 1024 * 1024; // 10MB
    const validFiles = [];
    let errorMessage = "";
  
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.indexOf("image") === 0) {
        const blob = item.getAsFile();
        if (blob.size <= maxSize) {
          validFiles.push(blob);
          const imageURL = URL.createObjectURL(blob);
          setImageData(blob);
          setImageURL(imageURL);
        } else {
          errorMessage = "Please select files up to 10MB in size.";
        }
      }
    }
  
    if (errorMessage) {
      setErrMsg(errorMessage);
    } else {
      setUploadFiles(validFiles);
    }
  };

  const handleFileChange = (e) => {
    setImageURL(null);
    if (imageRef.current) {
      imageRef.current.value = null;
    }

    const files = Array.from(e.target.files);
    const maxSize = 10 * 1024 * 1024;
    const validFiles = [];

    files.forEach((file) => {
      if (file.size <= maxSize) {
        validFiles.push(file);
      } else {
        setErrMsg("Please select files up to 10MB in size.");
      }
    });

    setUploadFiles(validFiles);

  };

  const hasAttachments = commetData.data && commetData.data.some(comment =>
    comment.history_data.some(data =>
      data.field_name === "Attachments" && Array.isArray(data.field_value) && data.field_value.length > 0
    )
  );
  
  return (
    <>
      {Loder ? null : (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={flag}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          style={{ overflow: "scroll" }}
        >
          <Fade in={flag}>
            <Box className="modalDiv" sx={style}>
              <TableContainer component={Paper}>
                <Table sx={{ overflow: "auto" }} aria-label="customized table">
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#2065d1" }}>
                      <StyledTableCell align="center">
                        Ticket Id
                      </StyledTableCell>
                      <StyledTableCell align="center">{id || ticketId}</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell
                        component="th"
                        align="center"
                        scope="row"
                        style={{
                          border: "1px solid #DFE1E4",
                          maxWidth: 80,
                        }}
                      >
                        Summary
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{
                          borderBottom: "1px solid #DFE1E4",
                          borderRight: "1px solid #DFE1E4",
                        }}
                      >
                        {allData.summary}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell
                        component="th"
                        align="center"
                        scope="row"
                        style={{
                          border: "1px solid #DFE1E4",
                          maxWidth: 80,
                        }}
                      >
                        Status
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{
                          borderBottom: "1px solid #DFE1E4",
                          borderRight: "1px solid #DFE1E4",
                        }}
                      >
                        {allData.status}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell
                        component="th"
                        align="center"
                        scope="row"
                        style={{
                          border: "1px solid #DFE1E4",
                          maxWidth: 80,
                        }}
                      >
                        Created Date
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{
                          borderBottom: "1px solid #DFE1E4",
                          borderRight: "1px solid #DFE1E4",
                        }}
                      >
                        {allData.created_date}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell
                        component="th"
                        align="center"
                        scope="row"
                        style={{
                          border: "1px solid #DFE1E4",
                          maxWidth: 80,
                        }}
                      >
                        Issue Type
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{
                          borderBottom: "1px solid #DFE1E4",
                          borderRight: "1px solid #DFE1E4",
                        }}
                      >
                        {allData.issue_type}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell
                        component="th"
                        align="center"
                        scope="row"
                        style={{
                          border: "1px solid #DFE1E4",

                          maxWidth: 80,
                        }}
                      >
                        Assignee
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{
                          borderBottom: "1px solid #DFE1E4",
                          borderRight: "1px solid #DFE1E4",
                        }}
                      >
                        {allData.assignee}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell
                        component="th"
                        align="center"
                        scope="row"
                        style={{
                          border: "1px solid #DFE1E4",
                          maxWidth: 80,
                        }}
                      >
                        Priority
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{
                          borderBottom: "1px solid #DFE1E4",
                          borderRight: "1px solid #DFE1E4",
                        }}
                      >
                        {allData.tt_priority}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell
                        component="th"
                        align="center"
                        scope="row"
                        style={{
                          border: "1px solid #DFE1E4",

                          maxWidth: 80,
                        }}
                      >
                        Expected Time to Resolve
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{
                          borderBottom: "1px solid #DFE1E4",
                          borderRight: "1px solid #DFE1E4",
                        }}
                      >
                        {allData.sla}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell
                        component="th"
                        align="center"
                        scope="row"
                        style={{
                          border: "1px solid #DFE1E4",

                          maxWidth: 80,
                        }}
                      >
                        Description
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{
                          borderBottom: "1px solid #DFE1E4",
                          borderRight: "1px solid #DFE1E4",
                        }}
                      >
                        {allData.ticket_des}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>

                {/* <Box
                  style={{
                    maxHeight: 170,
                    width: "100%",
                    overflow: "auto",
                    marginTop: "5px",
                    display: hasAttachments ? "block" : "none",
                  }}
                >
                  <Table>
                    <TableBody style={{ width: "100%" }}>
                      <StyledTableRow>
                        <StyledTableCell
                          align="center"
                          style={{
                            border: "1px solid #DFE1E4",
                            fontSize: "20px",
                            fontWeight: 600,
                          }}
                          colSpan={2}
                        >
                          Attachments
                        </StyledTableCell>
                      </StyledTableRow>

                      {commetData.data && commetData.data.map((comment, index) => {
                        if (comment.created_by === "supporttool@meon.co.in") {
                          return comment.history_data.map((data, dataIndex) => {
                            if (data.field_name === "Attachments" && Array.isArray(data.field_value)) {
                              return data.field_value.map((url, urlIndex) => {
                                const fileName = url.substring(url.lastIndexOf('/') + 1, url.indexOf('?'));
                                return (
                                  <StyledTableRow key={`${index}-${dataIndex}-${urlIndex}`}>
                                    <StyledTableCell
                                      align="center"
                                      style={{
                                        border: "1px solid #DFE1E4",
                                      }}
                                      colSpan={2}
                                    >
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="start"
                                        spacing={1}
                                      >
                                        <Typography variant="body1">
                                          <strong>File:</strong> {fileName}
                                        </Typography>
                                        <Button
                                            onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
                                          >
                                            View
                                        </Button>
                                        <Button>
                                          <Icon
                                            icon="ic:round-file-download"
                                            width="23"
                                            height="23"
                                            onClick={() => handleDownload(url)}
                                            />
                                        </Button>
                                      </Stack>
                                    </StyledTableCell>
                                  </StyledTableRow>
                                );
                              });
                            }
                            return null;
                          });
                        }
                        return null;
                      })}

                    </TableBody>
                  </Table>
                </Box> */}

                <Box
                  style={{
                    maxHeight: 250,
                    width: "100%",
                    overflow: "auto",
                    marginTop: "5px",
                    display: commetData.data && commetData.data.length > 0 ? "block" : "none",
                  }}
                >
                  <Table>
                    <TableBody style={{ width: "100%" }}>
                      <StyledTableRow>
                        <StyledTableCell
                          align="center"
                          style={{
                            border: "1px solid #DFE1E4",
                            fontSize: "20px",
                            fontWeight: 600,
                          }}
                          colSpan={2}
                        >
                          Comments
                        </StyledTableCell>
                      </StyledTableRow>

                      {commetData.data && commetData.data.length > 0 && commetData.data.map((comment, index) => {
                        const hasCommentOrAttachment = comment.history_data.some(data => data.field_name === "comment" || data.field_name === "Attachments");
                        return hasCommentOrAttachment && (
                          <StyledTableRow key={index}>
                            <StyledTableCell
                              align="center"
                              style={{
                                border: "1px solid #DFE1E4",
                              }}
                              colSpan={2}
                            >
                              <Stack
                                direction="column"
                                alignItems="start"
                                justifyContent="start"
                                spacing={1}
                              >
                                <Box
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                  }}
                                >
                                  <Typography variant="h6">
                                    {comment.created_by === "Support Tool API (supporttool@meon.co.in)" ? "You" : "Meon Team"}
                                  </Typography>
                                  <Typography variant="body1">
                                    {new Date(comment.created_at).toLocaleString(undefined, {
                                      year: 'numeric',
                                      month: '2-digit',
                                      day: '2-digit',
                                      hour: '2-digit',
                                      minute: '2-digit'
                                    })}
                                  </Typography>
                                </Box>
                                {comment.history_data.map((data, dataIndex) => (
                                  data.field_name === "comment" && (
                                    <Typography key={dataIndex} variant="body1" align="left">
                                      {data.field_value}
                                    </Typography>
                                  )
                                ))}
                                {comment.history_data.map((data, dataIndex) => (
                                  data.field_name === "Attachments" && Array.isArray(data.field_value) && data.field_value.map((url, urlIndex) => {
                                    const fileName = url.substring(url.lastIndexOf('/') + 1, url.indexOf('?'));
                                    return (
                                      <Box
                                        key={`${index}-${dataIndex}-${urlIndex}`}
                                        style={{ marginTop: "10px" }}
                                      >
                                        <Stack
                                          direction="row"
                                          alignItems="center"
                                          justifyContent="start"
                                          spacing={1}
                                        >
                                          <Typography variant="body1">
                                            <strong>File:</strong> {fileName}
                                          </Typography>
                                          <Button
                                            onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
                                          >
                                            View
                                          </Button>
                                          <Button>
                                            <Icon
                                              icon="ic:round-file-download"
                                              width="23"
                                              height="23"
                                              onClick={() => handleDownload(url)}
                                              />
                                          </Button>
                                        </Stack>
                                      </Box>
                                    );
                                  })
                                ))}
                              </Stack>
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Box>
                <Stack spacing={2}>
                  <TextField
                    error={errMsg ? true : false}
                    id="outlined-basic"
                    sx={{ width: "100%", marginTop: "10px" }}
                    label="Comments For Issue !"
                    variant="outlined"
                    inputRef={inputRef}
                    onChange={() => {
                      setErrMsg("");
                    }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "small",
                      textAlign: "left",
                    }}
                  >
                    {errMsg}
                  </p>
                  <Box style={{ padding: "20px", border: "1px dashed black" }}>
                    <input
                      type="file"
                      name=""
                      sx={{ width: "100%" }}
                      ref={fileInputRef}
                      accept="*/*"
                      id=""
                      onChange={handleFileChange}
                      multiple
                    />
                  </Box>
                </Stack>
                <Box sx={{ color: "#00000087", textAlign: "center" }}>
                  <Typography>Or</Typography>
                </Box>

                <Box
                  onPaste={handlePaste}
                  sx={{
                    minHeight: 100,
                    padding: "15px",
                    border: "1px dashed black",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {imageURL && (
                    <button>
                      <Icon
                        icon={"basil:cross-outline"}
                        width={24}
                        height={24}
                        onClick={() => {
                          setImageURL(null);
                          if (imageRef.current) {
                            imageRef.current.value = null;
                          }
                        }}
                      />
                    </button>
                  )}
                  {!imageURL ? <p>Paste Your Copied Image</p> : ""}
                    <img
                      ref={imageRef}
                      src={imageURL}
                      style={{ maxHeight: 100 }}
                      alt=""
                    />
                  </Box>
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="end"
                    alignContent="flex-start"
                    sx={{ m: "15px" }}
                  >
                    <Button
                      variant="contained"
                      sx={{ width: "140px", boxShadow: "none" }}
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="outlined"
                      sx={{ width: "140px" }}
                      onClick={handleClose}
                    >
                      Close
                    </Button>
                  </Stack>
                </TableContainer>
              </Box>
            </Fade>
          </Modal>
        )}
      <Popup
        response={responseMsg}
        flag={isOpen}
        handleClose={handleClosePopUp}
      />
      <Popup response={sessionResponse} flag={sessionFlag} handleClose={handleSessionClose} />
      <Popup response="Request timed out. Please refresh the page." flag={timeoutFlag} handleClose={handleTimeoutClose} />
    </>
  );
};

export default TicketsDetailsPopUp;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#2065d1",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const style = {
  position: "absolute",
  top: "100%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "-webkit-fill-available",
  bgcolor: "background.paper",
  boxShadow: 10,
  textAlign: "center",
  borderRadius: 1,
  p: 2,
  overflow: "auto",
};
